import { render, staticRenderFns } from "./AppOverviewNotification.vue?vue&type=template&id=a9398150&scoped=true&"
import script from "./AppOverviewNotification.vue?vue&type=script&lang=ts&"
export * from "./AppOverviewNotification.vue?vue&type=script&lang=ts&"
import style0 from "./AppOverviewNotification.vue?vue&type=style&index=0&id=a9398150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9398150",
  null
  
)

export default component.exports